import React from 'react';
import type { FormField } from '../interfaces';
import { VedleggSelector } from './VedleggSelector';

export const AvfallDokumentType = 'Sluttrapport avfall';

type AvfallDokumentSelectorProps = {
    field: FormField;
    isReadOnly: boolean;
    isRequired: boolean;
    prosessInstansId: string;
};

export const AvfallDokumentSelector = ({
    field,
    isReadOnly,
    isRequired,
    prosessInstansId,
}: AvfallDokumentSelectorProps) => {
    return (
        <VedleggSelector
            field={field}
            isReadOnly={isReadOnly}
            isRequired={isRequired}
            prosessInstansId={prosessInstansId}
            attachmentType={AvfallDokumentType}
            maxNumberOfAttachments={1}
        />
    );
};
